import "@/App.css";
import { BrowserRouter, Routes, Route, Navigate } from "react-router-dom";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/lib/i18n";
import { SmoothScroll } from "@/components/SmoothScroll";
import { Navbar } from "@/components/Navbar";
import { Footer } from "@/components/Footer";
import { FloatingActions } from "@/components/FloatingActions";

import Home from "@/pages/Home";
import About from "@/pages/About";
import Products from "@/pages/Products";
import ProductDetail from "@/pages/ProductDetail";
import Catalogue from "@/pages/Catalogue";
import WhyRKJain from "@/pages/WhyRKJain";
import Enquiry from "@/pages/Enquiry";
import Contact from "@/pages/Contact";

function App() {
  return (
    <div className="App min-h-screen bg-sand">
      <LanguageProvider>
        <BrowserRouter>
          <SmoothScroll>
            <Navbar />
            <main>
              <Routes>
                <Route path="/" element={<Home />} />
                <Route path="/about" element={<About />} />
                <Route path="/products" element={<Products />} />
                <Route path="/products/:slug" element={<ProductDetail />} />
                <Route path="/catalogue" element={<Catalogue />} />
                <Route path="/why-rk-jain" element={<WhyRKJain />} />
                <Route path="/enquiry" element={<Enquiry />} />
                <Route path="/contact" element={<Contact />} />
                <Route path="*" element={<Navigate to="/" replace />} />
              </Routes>
            </main>
            <Footer />
            <FloatingActions />
          </SmoothScroll>
        </BrowserRouter>
        <Toaster position="top-center" richColors />
      </LanguageProvider>
    </div>
  );
}

export default App;
